module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select-input', {
    attrs: {
      "label": _vm.label,
      "value-key": "value",
      "label-value": "label",
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "list": _vm.selectData,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347a71d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectRateCategory.vue
// module id = 1411
// module chunks = 0